// External imports
import { useEffect, useState } from "react";

// Local imports
import classes from "./style.module.css";
import languageConfig from "@/export/config";
import DownloadLink from "../../DownloadLink";

// Component props for Preview
interface Props {
  cssName: string;
  downloadPath: string;
}

export default function Preview({ cssName, downloadPath }: Props) {
  const [fontSize, setFontSize] = useState(32);
  const [text, setText] = useState("");

  useEffect(() => {
    if (window.location.hash) {
      setText(decodeURIComponent(window.location.hash.split("#")[1]));
    } else {
      setText(languageConfig?.routes.fonts?.input.textOptions[0] || "");
    }
  }, []);

  return (
    <div className={`${classes.container}`}>
      <div className={`${classes.slider}`}>
        <input
          type="range"
          min={12}
          max={64}
          value={fontSize}
          step={2}
          onChange={(e) => setFontSize(parseInt(e.target.value))}
        />

        <span>{fontSize} px</span>
      </div>

      <p
        className={`${classes.preview}`}
        style={{
          fontFamily: cssName,
          fontSize: fontSize,
        }}
      >
        {text}
      </p>

      <DownloadLink downloadPath={downloadPath} />
    </div>
  );
}
